/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_ServerInputs */

const en_mobile_upload_error_server = /** @type {(inputs: Mobile_Upload_Error_ServerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server error. Please try again later.`)
};

const es_mobile_upload_error_server = /** @type {(inputs: Mobile_Upload_Error_ServerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error del servidor. Inténtalo de nuevo más tarde.`)
};

/**
* | output |
* | --- |
* | "Server error. Please try again later." |
*
* @param {Mobile_Upload_Error_ServerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_server = /** @type {((inputs?: Mobile_Upload_Error_ServerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_ServerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_server(inputs)
	return en_mobile_upload_error_server(inputs)
});